import { render, staticRenderFns } from "./InventoryAddedItem.vue?vue&type=template&id=31c9ab6e&"
import script from "./InventoryAddedItem.vue?vue&type=script&lang=ts&"
export * from "./InventoryAddedItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports